import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import TStore from '../../../../types/store';
import { useIntl } from 'react-intl';
import { ICalendarEvents } from '../../../../components/ui/calendar/calendars';
import { EVisitItem, IEVisitEvents } from '../../../../types/e-visits';
import { format } from 'date-fns';

export function connectReservationForm(fetch: () => void, calendarRef: React.RefObject<any>) {
  const { formatMessage } = useIntl();
  const { formState } = useSelector((state: TStore) => ({
    formState: state.reservationForm.formState,
  }));

  useEffect(() => {
    if (formState === 'submit_success') {
      calendarRef.current?.closeMenu(true);
      fetch();
    }
  }, [formatMessage, formState, fetch, calendarRef]);

  return {};
}

export function mapEvents(calendarEvents: IEVisitEvents | undefined) {
  const result: ICalendarEvents<EVisitItem> = {};

  if (calendarEvents) {
    for (const key in calendarEvents) {
      if (Object.prototype.hasOwnProperty.call(calendarEvents, key)) {
        const element = calendarEvents[key];

        result[format(new Date(key), 'yyyy-MM-dd')] = element.map((e) => ({
          end: e.event.to,
          start: e.event.from,
          eventData: e,
        }));
      }
    }
  }

  return Object.values(result).flat();
}
